// extracted by mini-css-extract-plugin
var _1 = "src-components-EditNotePage-_TextDialog__dialogCloseButton--cGr6Tewj1RVetSaSyt6w";
var _2 = "src-components-EditNotePage-_TextDialog__dialogCloseButtonWrapper--vkckcH9lxx41Ly_bpIdj";
var _3 = "src-components-EditNotePage-_TextDialog__dialogText--iTHXrEB5RQVxMPR2yHA_";
var _4 = "src-components-EditNotePage-_TextDialog__textDialog--EwPIS4bTbCADV8sIwqLm";
export { _1 as "dialogCloseButton", _2 as "dialogCloseButtonWrapper", _3 as "dialogText", _4 as "textDialog" }
